export default "__VITE_ASSET__Bd$uclPb__"